import { render, staticRenderFns } from "./StorageServices.vue?vue&type=template&id=6d9a6efb&scoped=true"
import script from "./StorageServices.vue?vue&type=script&lang=js"
export * from "./StorageServices.vue?vue&type=script&lang=js"
import style0 from "./StorageServices.vue?vue&type=style&index=0&id=6d9a6efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a6efb",
  null
  
)

export default component.exports